import React from 'react';

import Generic48Icon from '@atlaskit/icon-file-type/glyph/generic/48';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import Tooltip from '@atlaskit/tooltip';

import { AttachmentFile } from '@qality/common-model/src/Attachment';

import './_test-case-box-step.scss';

const IS_OPEN_MODAL = true;

type Props = {
  file: AttachmentFile;
  index: number;
  removeAttachment: (fileId: number) => void;
  enlargeAttachment: (index: number, isOpen: boolean) => void;
};

export default function AttachmentsNewThumb({
  file,
  index,
  removeAttachment,
  enlargeAttachment,
}: Props): JSX.Element {
  return (
    <Tooltip content={file.name} testId='attachment-tooltip'>
      <div className='attachment-container'>
        {file.type.includes('image') ? (
          <img
            alt='Attachment'
            className='attachment-container-image'
            src={file.content}
            onClick={() => enlargeAttachment(index, IS_OPEN_MODAL)}
          />
        ) : (
          <div
            className='attachment-other-type'
            onClick={() => enlargeAttachment(index, IS_OPEN_MODAL)}
          >
            <Generic48Icon label='' />
          </div>
        )}
        <span
          className='attachment-remove-icon'
          onClick={() => removeAttachment(index)}
        >
          <CrossCircleIcon size='small' label='' />
        </span>
      </div>
    </Tooltip>
  );
}
